/** Maps a backend SessionState to a short label + Tailwind chip classes. */
export function statusBadge(state: string): { label: string; cls: string } {
  switch (state) {
    case "Created":
    case "GatheringParticipants":
      return { label: "Gathering", cls: "bg-cream-200 text-ink/70" };
    case "IndividualCuration":
    case "ConsensusBuilding":
      return { label: "Curating", cls: "bg-primary-100 text-primary-700" };
    case "Narrowing":
      return { label: "Narrowing", cls: "bg-primary-100 text-primary-700" };
    case "Voting":
    case "TieBreak":
      return { label: "Voting", cls: "bg-primary-100 text-primary-700" };
    case "Decided":
    case "AwaitingFeedback":
      return { label: "Decided", cls: "bg-green-100 text-green-700" };
    case "Cancelled":
      return { label: "Cancelled", cls: "bg-stone-200 text-stone-500" };
    case "Closed":
      return { label: "Closed", cls: "bg-stone-200 text-stone-600" };
    default:
      return { label: state, cls: "bg-stone-200 text-stone-600" };
  }
}

/** A session is still live (worth polling) until it's decided or cancelled. */
export function isLive(state: string): boolean {
  return state !== "Decided" && state !== "AwaitingFeedback" && state !== "Closed" && state !== "Cancelled";
}
